module.exports = __webpack_public_path__ + "img/logo-serviceportal_hessenmetall_264x85.efc9e263.png";